export const BRANDING = {
  name: 'BVRIT Hyderabad College of Engineering for Women',
  shortName: 'BVRIT Hyderabad',
  /** Served from `frontend-react/public/logo.png` (uses `PUBLIC_URL` when app is under a subpath). */
  logoUrl: `${process.env.PUBLIC_URL || ''}/logo.png`,
  productName: 'StackTrack',
};
